import { useEffect, useState } from "react";

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [moreInfo, setMoreInfo] = useState(false);
  const [preferences, setPreferences] = useState({
    functional: false,
    analytics: false,
    performance: false,
    advertisement: false,
  });

  // On load, check consent
  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (consent !== "accepted" && consent !== "rejected") {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
    setShowModal(false);
  };

  const handleRejectAll = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShowBanner(false);
    setShowModal(false);
  };

  const handleSavePreferences = () => {
    localStorage.setItem("cookiePreferences", JSON.stringify(preferences));
    localStorage.setItem("cookieConsent", "customized");
    setShowBanner(false);
    setShowModal(false);
  };

  return (
    <>
      {/* Cookie Banner */}
      {showBanner && (
        <div className="fixed bottom-0 left-0 w-full bg-white border border-gray-300 shadow-md p-5 z-[9999]">
          {/* <div className="max-w-4xl mx-auto"> */}
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              We value your privacy
            </h3>
            <p className="text-sm text-gray-700 mb-3">
              We use cookies to enhance your browsing experience, serve
              personalized ads or content, and analyze our traffic. By clicking{" "}
              <strong>Accept All</strong>, <br/> you consent to our use of cookies.{" "}
              <a href="#" className="text-blue-600 underline">
                Cookie Policy
              </a>
            </p>
            <div className="flex flex-wrap justify-end gap-3">
              <button
                onClick={() => setShowModal(true)}
                className="px-4 py-2 border border-pink-600 text-pink-600 rounded-md hover:bg-pink-50 cursor-pointer"
              >
                Customize
              </button>
              <button
                onClick={handleRejectAll}
                className="px-4 py-2 border border-red-600 text-red-600 rounded-md hover:bg-red-50 cursor-pointer"
              >
                Reject All
              </button>
              <button
                onClick={handleAcceptAll}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 cursor-pointer"
              >
                Accept All
              </button>
            </div>
          {/* </div> */}
        </div>
      )}

      {/* Customize Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[10000]">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto relative p-6">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-3 right-3 text-2xl text-gray-600 hover:text-red-600 cursor-pointer"
            >
              &times;
            </button>

            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              Customise Consent Preferences
            </h3>
            <p className="text-sm text-gray-700 mb-3">
              About all cookies under each consent category below.
            </p>
            <p className="text-sm text-gray-700">
              The cookies that are categorised as{" "}
              <strong>Necessary</strong> are stored on your browser as they are
              essential for enabling the basic functionalities of the site...{" "}
              <button
                onClick={() => setMoreInfo(!moreInfo)}
                className="text-blue-600 underline cursor-pointer"
              >
                {moreInfo ? "Show less" : "Show more"}
              </button>
            </p>

            {moreInfo && (
              <div className="mt-2 text-sm text-gray-600">
                <p>
                  We also use third-party cookies that help us analyse how you
                  use this website, store your preferences, and provide the
                  content and advertisements that are relevant to you.
                </p>
                <p className="mt-2">
                  You can choose to enable or disable some or all of these
                  cookies but disabling some of them may affect your browsing
                  experience.
                </p>
              </div>
            )}

            {/* Consent Categories */}
            <div className="mt-5 space-y-4">
              <div>
                <label className="flex items-center gap-2 font-semibold">
                  <input type="checkbox" checked disabled className="accent-gray-400" />
                  Necessary <span className="text-sm font-normal text-gray-500">(Always Active)</span>
                </label>
                <p className="text-sm text-gray-600 mt-1">
                  Necessary cookies are required to enable the basic features of
                  this site...
                </p>
              </div>

              {["functional", "analytics", "performance", "advertisement"].map(
                (key) => (
                  <div key={key}>
                    <label className="flex items-center gap-2 font-semibold capitalize">
                      <input
                        type="checkbox"
                        checked={preferences[key as keyof typeof preferences]}
                        onChange={(e) =>
                          setPreferences((prev) => ({
                            ...prev,
                            [key]: e.target.checked,
                          }))
                        }
                        className="accent-blue-600"
                      />
                      {key}
                    </label>
                    <p className="text-sm text-gray-600 mt-1">
                      {key === "functional" &&
                        "Helps perform certain functionalities like sharing on social media, collecting feedback, etc."}
                      {key === "analytics" &&
                        "Used to understand how visitors interact with the website."}
                      {key === "performance" &&
                        "Helps analyse key performance indexes for better UX."}
                      {key === "advertisement" &&
                        "Used to provide customised ads based on your activity."}
                    </p>
                  </div>
                )
              )}
            </div>

            {/* Buttons */}
            <div className="flex flex-wrap justify-end gap-3 mt-6">
              <button
                onClick={handleRejectAll}
                className="px-4 py-2 border border-red-600 text-red-600 rounded-md hover:bg-red-50 cursor-pointer"
              >
                Reject All
              </button>
              <button
                onClick={handleSavePreferences}
                className="px-4 py-2 border border-gray-400 text-gray-700 rounded-md hover:bg-gray-100 cursor-pointer"
              >
                Save My Preferences
              </button>
              <button
                onClick={handleAcceptAll}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 cursor-pointer"
              >
                Accept All
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
